module.exports = __webpack_public_path__ + "img/widget_notes.659c235.png";